import gql from 'graphql-tag'

// Generic query used for any scope ('group' | 'organization' | 'user') — the shape
// is identical regardless of scope, only the variables differ.
export const GET_CHANNELS = gql`
  query GetChannels($scope: String!, $targetId: Int) {
    channels(scope: $scope, targetId: $targetId) {
      id
      provider
      channelType
      phoneNumber
      webhookToken
      assignedMemberIds
      isActive
      credentials
      webhookUrlTwilio
      webhookUrlBotmaker
    }
  }
`

export const GET_GROUP_CHANNELS = gql`
  query GetGroupChannels($scope: String!, $targetId: Int) {
    channels(scope: $scope, targetId: $targetId) {
      id
      provider
      channelType
      phoneNumber
      webhookToken
      assignedMemberIds
      isActive
      credentials
      webhookUrlTwilio
      webhookUrlBotmaker
    }
  }
`

export const GET_ORGANIZATION_CHANNELS = gql`
  query GetOrganizationChannels($scope: String!, $targetId: Int) {
    channels(scope: $scope, targetId: $targetId) {
      id
      provider
      channelType
      phoneNumber
      webhookToken
      assignedMemberIds
      isActive
      credentials
      webhookUrlTwilio
      webhookUrlBotmaker
    }
  }
`

export const GET_USER_CHANNELS = gql`
  query GetUserChannels($scope: String!, $targetId: Int) {
    channels(scope: $scope, targetId: $targetId) {
      id
      provider
      channelType
      phoneNumber
      webhookToken
      assignedMemberIds
      isActive
      credentials
      webhookUrlTwilio
      webhookUrlBotmaker
    }
  }
`
